import { playNotificationSound } from "@/utils/notification/soundUtils";

// Чаты используют общий тон, но не настройку звука центра уведомлений.
export function playChatUnreadSound() {
  return playNotificationSound();
}
